module.exports = __webpack_public_path__ + "static/media/jonathanfunes.7f427730.jpeg";